import {
    IServiceResult,
    ITerritoryType,
    IUserPreferences,
} from "../Models/Models";

export interface IUserPreferencesAxios {
  GetUserPreferences(): Promise<IServiceResult<IUserPreferences>>;
  UpdateUserPreferences(
    userPreferences: IUserPreferences
  ): Promise<IServiceResult<IUserPreferences>>;
  GetCompanyTerritoryTypes(): Promise<IServiceResult<Array<ITerritoryType>>>;
}
